import { queryOptions, useQuery } from '@tanstack/react-query';
import { type AmlReportLookup, fetchAmlReport, searchTransactions, type TransactionsSearchRequest } from '@/services/api/funds-transactions';

export const FUNDS_TRANSACTIONS_QUERY_KEY = ['funds', 'transactions'] as const;
// Separate search prefix so mutations can invalidate lists without refetching AML reports
export const FUNDS_TRANSACTIONS_SEARCH_QUERY_KEY = [...FUNDS_TRANSACTIONS_QUERY_KEY, 'search'] as const;

export const transactionsSearchQueryOptions = (request: TransactionsSearchRequest) =>
  queryOptions({
    queryKey: [...FUNDS_TRANSACTIONS_SEARCH_QUERY_KEY, request],
    queryFn: () => searchTransactions(request),
  });

export const useTransactionsSearch = (request: TransactionsSearchRequest) => useQuery(transactionsSearchQueryOptions(request));

export const amlReportQueryOptions = (lookup: AmlReportLookup) =>
  queryOptions({
    queryKey: [...FUNDS_TRANSACTIONS_QUERY_KEY, 'aml-report', lookup.transaction_id],
    queryFn: () => fetchAmlReport(lookup),
    // Non-404 lookup failures are swallowed by the caller (the detail dialog still
    // opens without a report, legacy parity) — don't burn retries on them either.
    retry: false,
  });

export const useAmlReport = (lookup: AmlReportLookup) => useQuery(amlReportQueryOptions(lookup));
